import React, { useEffect, useState } from "react";
import { Activity } from "lucide-react";

/**
 * LivePulseIndicator — a tiny "system is alive" badge that pings every 12s and
 * updates a relative-time label like "מעודכן · לפני 14 שניות". For the demo
 * this fakes a sense of "live data stream from Priority" without an actual
 * polling loop on a real endpoint (we just re-anchor the clock).
 *
 * It re-anchors itself every 90s to suggest periodic ERP sync events.
 */
export default function LivePulseIndicator() {
  const [lastSync, setLastSync] = useState(() => Date.now());
  const [, setTick] = useState(0);

  useEffect(() => {
    const ui = setInterval(() => setTick((t) => t + 1), 1000);
    const sync = setInterval(() => setLastSync(Date.now()), 90_000);
    return () => {
      clearInterval(ui);
      clearInterval(sync);
    };
  }, []);

  const seconds = Math.max(0, Math.floor((Date.now() - lastSync) / 1000));
  const label = seconds < 60 ? `לפני ${seconds} שניות` : `לפני ${Math.floor(seconds / 60)} דקות`;

  return (
    <div
      className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md bg-primary/[0.06] border border-primary/15 text-[10px] text-zinc-400 font-mono"
      data-testid="live-pulse-indicator"
      title="המערכת מסונכרנת עם Priority בזמן אמת"
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-60" />
        <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-primary" />
      </span>
      <Activity className="w-2.5 h-2.5 text-primary/70" strokeWidth={1.75} />
      <span>סנכרון · {label}</span>
    </div>
  );
}
